var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-waiting"},[_vm._v("\n    请前往授权页面授权登录或者"),_c('a',{attrs:{"href":"http://www.renrendonghua.com"}},[_vm._v("返回首页")])])}]

export { render, staticRenderFns }